export interface EntryTypeDto {
  entryTypeId: number;
  entryTypeCode: string;
  entryTypeName: string;
  entryTypeNameAr: string;
  prefix: string;
  category: string;
  description?: string;
  isActive: boolean;
  requiresApproval: boolean;
  allowManualEntry: boolean;
  createdDate: string;
}

export interface EntryTypeSummaryDto {
  entryTypeId: number;
  entryTypeCode: string;
  entryTypeName: string;
  entryTypeNameAr: string;
  prefix: string;
  category: string;
  isActive: boolean;
}

export type EntryTypeCategory =
  | 'Manual'
  | 'Cash'
  | 'Purchase'
  | 'Sales'
  | 'Inventory'
  | 'Adjustment'
  | 'Custody'
  | 'Payroll';

export const EntryTypeCategoryLabels: Record<EntryTypeCategory, { en: string; ar: string }> = {
  Manual: { en: 'Manual Entries', ar: 'قيود يدوية' },
  Cash: { en: 'Cash Transactions', ar: 'المعاملات النقدية' },
  Purchase: { en: 'Purchase Transactions', ar: 'معاملات المشتريات' },
  Sales: { en: 'Sales Transactions', ar: 'معاملات المبيعات' },
  Inventory: { en: 'Inventory Transactions', ar: 'معاملات المخزون' },
  Adjustment: { en: 'Adjustments', ar: 'التسويات' },
  Custody: { en: 'Custody Transactions', ar: 'معاملات العهد' },
  Payroll: { en: 'Payroll Transactions', ar: 'معاملات الرواتب' },
};